<label class="container my-2">
    <input type="checkbox" [(ngModel)]="checkbox" (click)="checkboxClicked()">
    <span class="checkmark"></span>
    <span class="ms-3 checkmark-text">{{text}}</span>
</label>